export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function retryAsync(fn, {
  retries = 2,
  baseDelayMs = 700,
  factor = 1.8,
  shouldRetry = () => true,
  onRetry = () => {},
} = {}) {
  let lastError;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      return await fn(attempt);
    } catch (error) {
      lastError = error;
      if (attempt >= retries || !shouldRetry(error)) break;
      onRetry(error, attempt + 1);
      await delay(Math.round(baseDelayMs * (factor ** attempt)));
    }
  }

  throw lastError;
}
